import { render, staticRenderFns } from "./SupplierRestrictedData.vue?vue&type=template&id=6f9c4e6f&"
import script from "./SupplierRestrictedData.vue?vue&type=script&lang=js&"
export * from "./SupplierRestrictedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports